import React, {useContext, useState} from "react"
import PropTypes from "prop-types"

import {AppContext} from "../components/context/AppContext"
import {UploadForm} from "../components/forms"

import {SubmissionApi} from "../utils/api"
import {ROUTE_PATHS} from "../utils/routes"
import AnalyticsService from "../utils/AnalyticsService"

export const Upload = (props) => {
  const {state, dispatch} = useContext(AppContext)
  const [submitting, setSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const upload = async () => {
    try {
      AnalyticsService.sendEvent("Upload Site", "Submission Upload", "Upload", {event: "file_uploaded"})
      return await SubmissionApi.upload(state.files, state.iSubmission.iSubmitId,)
    } catch (error) {
      throw error
    }
  }

  const finalize = async () => {
    try {
      if (state.iSubmission.TFBRole === "") {
        state.iSubmission.TFBRole = "Empty:"+state.user.TFBRole
      }
      const submission = {...state.iSubmission, userPhoneNumbers: state.user.phoneNumbers, offerId: state.campaign.offerId}
      AnalyticsService.sendEvent("Upload Site", "Submission Upload", "Upload", {event: "submitted"})
      return await SubmissionApi.finalize(submission)
    } catch (error) {
      throw error
    }
  }

  const onSubmit = async () => {
    try {
      setSubmitting(true)

      setErrorMessage("")

      if (state.files.length === 0) {
        setErrorMessage("You must upload at least one file")
        setSubmitting(false)
        return
      }

      await upload()

      const result = await finalize()

      dispatch({type: "SETISUBMISSION", payload: result})
      dispatch({type: "SETSUBMITTED", payload: true})

      setSubmitting(false)

      props.history.push(ROUTE_PATHS.THANKS)

    } catch (error) {
      setErrorMessage("Something went wrong please try again")
      setSubmitting(false)
    }
  }

  return (
    <section>
      <div className="container hero3">
        <div className="row">
          <div className="col-md-12">
            <h1 className="magenta mb-4">Upload some images and you&apos;re done.</h1>
            <UploadForm instructions={state.campaign.productList} handleSubmit={onSubmit} isSubmitting={submitting} errorMessage={errorMessage} />
          </div>
        </div>
      </div>
    </section>
  )
}

Upload.propTypes = {
  history: PropTypes.object
}

Upload.requiresAuth = true
